'use client';
import React from 'react';
import type { Store } from './storeData';
import Icon from '@/components/ui/AppIcon';

interface MapPlaceholderProps {
  stores: Store[];
  selectedStore: Store | null;
  onSelectStore: (store: Store) => void;
}

export default function MapPlaceholder({ stores, selectedStore, onSelectStore }: MapPlaceholderProps) {
  return (
    <div className="relative mx-4 my-3 h-48 bg-accent rounded-2xl overflow-hidden border border-border card-shadow">
      {/* Fake map grid */}
      <div className="absolute inset-0">
        <div className="w-full h-full" style={{ backgroundImage: 'linear-gradient(var(--border) 1px, transparent 1px), linear-gradient(90deg, var(--border) 1px, transparent 1px)', backgroundSize: '40px 40px' }} />
      </div>

      {/* Istanbul label */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="text-center opacity-40">
          <p className="text-foreground font-bold text-lg">İstanbul</p>
          <p className="text-muted-foreground text-xs">Harita Görünümü</p>
        </div>
      </div>

      {/* Fake road lines */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/3 left-0 right-0 h-0.5 bg-white/50 rounded" />
        <div className="absolute top-2/3 left-0 right-0 h-0.5 bg-white/30 rounded" />
        <div className="absolute left-1/3 top-0 bottom-0 w-0.5 bg-white/40 rounded" />
        <div className="absolute left-2/3 top-0 bottom-0 w-0.5 bg-white/30 rounded" />
      </div>

      {/* Store pins */}
      {stores.slice(0, 5).map((store, i) => {
        const positions = [
          { top: '25%', left: '20%' },
          { top: '40%', left: '55%' },
          { top: '60%', left: '30%' },
          { top: '30%', left: '70%' },
          { top: '70%', left: '60%' },
        ];
        const pos = positions[i] || { top: '50%', left: '50%' };
        const isSelected = selectedStore?.id === store.id;
        return (
          <button
            key={`pin-${store.id}`}
            onClick={() => onSelectStore(store)}
            className={`absolute transform -translate-x-1/2 -translate-y-1/2 transition-all duration-150 ${isSelected ? 'scale-125 z-10' : 'hover:scale-110'}`}
            style={{ top: pos.top, left: pos.left }}
          >
            <div className={`w-8 h-8 rounded-full border-2 border-white flex items-center justify-center card-shadow ${
              store.status === 'open' ? 'bg-primary' : store.status === 'closing-soon' ? 'bg-warning' : 'bg-muted-foreground'
            }`}>
              <Icon name="MapPinIcon" size={14} className="text-white" />
            </div>
            {isSelected && (
              <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 bg-foreground text-white text-[10px] font-bold px-2 py-1 rounded-lg whitespace-nowrap">
                {store.name}
              </div>
            )}
          </button>
        );
      })}

      {/* Map attribution */}
      <div className="absolute bottom-2 right-2 bg-white/80 rounded px-2 py-0.5">
        <p className="text-[9px] text-muted-foreground">Harita Önizleme</p>
      </div>
    </div>
  );
}